import { api } from '@/plugins/api';

const state = {
  factureUrl: "",
  typeFacture: ""
}

const getters = {
  GET_FACTUREURL: (state) => { return state.factureUrl },
  GET_TYPEFACTURE: (state) => { return state.typeFacture }
}

const mutations = {
  SET_FACTUREURL(state, payload) {
    state.factureUrl = payload
  },
  SET_TYPEFACTURE (state, payload) {
    state.typeFacture = payload
  }
}

const actions = {
  getFacture: ({ commit }, factureId) => api.get('factures/' + factureId),
  preloadRequest: ({ commit }, payload) => api.get('moneris-checkout/' + payload.factureId + '/preload/' + payload.langue),
  receiptRequest: ({ commit }, payload) => api.post('moneris-checkout/' + payload.factureId + '/receipt', { token: payload.token }),
  async getLienFactureByDemandeAdmissionId({ commit }, encodedDemandeAdmissionId) {
    const response = await api.get(`factures/demandeadmission/${encodedDemandeAdmissionId}`);
    commit('SET_FACTUREURL', response.data ? response.data : "");
  },
  async getLienFactureByDemandeInscriptionId({ commit }, encodedDemandeInscriptionId) {
    const response = await api.get(`factures/demandeinscription/${encodedDemandeInscriptionId}`);
    commit('SET_FACTUREURL', response.data ? response.data : "");
  },
  async getTypeFacture ({ commit }, factureId) {
    const response = await api.get(`factures/${factureId}/type`);
    commit('SET_TYPEFACTURE', response.data ? response.data : "");
  }
}

export default ({
  namespaced: true,
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
})